import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './TopCategoriesBar.css';

const TopCategoriesBar = () => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    // Close dropdown and mobile menu when route changes
    // Close dropdown and mobile menu when route changes
    useEffect(() => {
        setActiveDropdown(null);
        setMobileMenuOpen(false);
    }, [location.pathname]);

    // Close dropdown when clicking outside or pressing ESC
    useEffect(() => {
        const handleClickOutside = (event) => {
            const topBar = document.querySelector('.top-categories-bar');
            if (topBar && !topBar.contains(event.target)) {
                setActiveDropdown(null);
                setMobileMenuOpen(false);
            }
        };

        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                setActiveDropdown(null);
                setMobileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscKey);
        };
    }, []);

    const isHebrew = location.pathname.startsWith('/he') || location.pathname === '/pricing-he' || location.pathname === '/Pricing-Calculator';

    const categories = isHebrew ? [
        {
            id: 'webhosting',
            title: 'אחסון אתרים',
            items: [
                { title: 'אחסון שיתופי', link: '/shared-hosting' },
                { title: 'אחסון וורדפרס', link: '/wordpress-hosting' },
                { title: 'אחסון WooCommerce', link: '/he/woocommerce' },
                { title: 'אחסון Next.js', link: '/nextjs-hosting' },
            ]
        },
        {
            id: 'compute',
            title: 'Compute',
            items: [
                { title: 'Core VPS', link: '/compute#core' },
                { title: 'Edge VPS', link: '/compute#edge' },
                { title: 'MTI-L VPS', link: '/compute#mti-l' },
            ]
        },
        {
            id: 'wordpress',
            title: 'וורדפרס',
            items: [
                { title: 'וורדפרס ללא ניהול', link: '/unmanaged-wordpress' },
                { title: 'וורדפרס מנוהל (עברית)', link: '/he/wordpress' },
                { title: 'וורדפרס מנוהל (אנגלית)', link: '/wordpress-en' },
                { title: 'וורדפרס WooCommerce (אנגלית)', link: '/woocommerce-en' },
            ]
        },
        {
            id: 'managed',
            title: 'שירותים מנוהלים',
            items: [
                { title: 'כל השירותים המנוהלים', link: '/he#managed-services' },
                { title: 'הגנת סייבר מנוהלת', link: '/he/managed-cyber-defence' },
                { title: 'CDN מנוהל - Cloudflare', link: '/he/managed-cdn' },
                { title: 'ניהול שרתים חיצוניים', link: '/he/server-management' },
                { title: 'ניהול AWS אוטומטי', link: '/he/managed-aws' },
                { title: 'מסד נתונים Aurora מנוהל', link: '/he/aurora-database' },
                { title: 'ניטור וגיבוי מרכזי', link: '/he/centralized-monitoring' },
                { title: 'מנוי DevOps לפי דרישה', link: '/he/devsecops-daily' },
            ]
        },
        {
            id: 'hybridcloud',
            title: 'ענן היברידי',
            items: [
                { title: 'שירות ענן היברידי', link: '/cloud-en' },
            ]
        },
        {
            id: 'cloudmarketplace',
            title: 'חנות מוצרים',
            items: [
                { title: 'ביקור בחנות הענן', link: 'https://epicfinal.com/marketplace', external: true, icon: 'la-shopping-cart' },
            ]
        },
        {
            id: 'clientlogin',
            title: 'כניסת לקוחות',
            items: [
                { title: 'כניסה לאחסון ענן', link: 'https://my.epicfinal.com/login', external: true, icon: 'la-sign-in-alt' },
                { title: 'הרשמת חשבון חדש', link: 'https://my.epicfinal.com/register.php', external: true, icon: 'la-user-plus' },
                { title: 'DevSecOps ONE', link: 'https://boarding.eu.epicfinal-cloud.com/login?lang=he', external: true, icon: 'la-sign-in-alt' },
            ]
        }
    ] : [
        {
            id: 'genai',
            title: 'GenAI Software Builder',
            directLink: '/genai'
        },
        {
            id: 'webhosting',
            title: 'Web Hosting',
            items: [
                { title: 'Shared Hosting', link: '/shared-hosting' },
                { title: 'WordPress Hosting', link: '/wordpress-hosting' },
                { title: 'Next.js Hosting', link: '/nextjs-hosting' },
            ]
        },
        {
            id: 'compute',
            title: 'Compute',
            items: [
                { title: 'Core VPS', link: '/compute#core' },
                { title: 'Edge VPS', link: '/compute#edge' },
                { title: 'MTI-L VPS', link: '/compute#mti-l' },
            ]
        },
        {
            id: 'wordpress',
            title: 'WordPress',
            items: [
                { title: 'Unmanaged WordPress', link: '/unmanaged-wordpress' },
                { title: 'Managed WordPress (English)', link: '/wordpress-en' },
                { title: 'Managed WooCommerce (English)', link: '/woocommerce-en' },
            ]
        },
        {
            id: 'managed',
            title: 'Managed Services',
            items: [
                // { title: 'Overview', link: '/managed-services' },
                { title: 'Managed Cyber Defence', link: '/managed-cyber-defence' },
                { title: 'Managed CDN - Cloudflare', link: '/managed-cdn' },
                { title: 'Server Management', link: '/server-management' },
                { title: 'AWS Auto Scaling & ECS', link: '/aws-management' },
                { title: 'Amazon Aurora Database', link: '/aurora-database' },
                { title: 'Centralized Monitoring', link: '/centralized-monitoring' },
                { title: 'DevSecOps ONE - Daily', link: '/devsecops-daily' },
                { title: 'DevSecOps ONE - Weekly', link: '/devsecops-weekly' },
            ]
        },
        {
            id: 'hybridcloud',
            title: 'Managed Hybrid Cloud',
            items: [
                { title: 'Hybrid Cloud Service', link: '/cloud-en' },
            ]
        },
        {
            id: 'clientlogin',
            title: 'Clients Login',
            items: [
                { title: 'Login to Cloud Hosting', link: 'https://my.epicfinal.com/login', external: true, icon: 'la-sign-in-alt' },
                { title: 'Register New Account', link: 'https://my.epicfinal.com/register.php', external: true, icon: 'la-user-plus' },
                { title: 'DevSecOps ONE', link: 'https://boarding.eu.epicfinal-cloud.com/login', external: true, icon: 'la-sign-in-alt' },
            ]
        }
    ];

    const handleMouseEnter = (categoryId) => {
        // Disabled hover - only click opens dropdown
        // setActiveDropdown(categoryId);
    };

    const handleMouseLeave = () => {
        // Disabled hover - only click closes dropdown
        // setActiveDropdown(null);
    };

    const handleCategoryClick = (categoryId) => {
        // Toggle dropdown on click (for mobile/touch devices)
        setActiveDropdown(activeDropdown === categoryId ? null : categoryId);
    };

    const handleLinkClick = () => {
        // Close dropdown and mobile menu when clicking a link
        setActiveDropdown(null);
        setMobileMenuOpen(false);
    };

    return (
        <div
            className={`top-categories-bar top-categories-bar--${isHebrew ? 'he' : 'en'}`}
            dir={isHebrew ? 'rtl' : 'ltr'}
        >
            <div className="container">
                {/* Mobile Hamburger Button */}
                <button 
                    className="mobile-hamburger-services"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle Services Menu"
                >
                    <span className="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                    <span className="hamburger-text">{isHebrew ? "אחסון ושירותים מנוהלים" : "Hosting & Managed Services"}</span>
                </button>

                <nav className={`categories-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
                    {categories.map((category) => (
                        <div
                            key={category.id}
                            className={`category-item${category.id === 'genai' ? ' category-item-genai' : ''}`}
                            onMouseEnter={() => handleMouseEnter(category.id)}
                            onMouseLeave={handleMouseLeave}
                        >
                            {category.directLink ? (
                                <Link
                                    to={category.directLink}
                                    className="top-category-link top-category-link-genai"
                                    onClick={handleLinkClick}
                                >
                                    {category.title}
                                </Link>
                            ) : (
                                <button 
                                    className="top-category-link"
                                    onClick={() => handleCategoryClick(category.id)}
                                    type="button"
                                >
                                    {category.id === 'clientlogin' && <i className="las la-user-circle"></i>}
                                    {category.title}
                                    <i className="las la-angle-down"></i>
                                </button>
                            )}
                            
                            {/* Regular dropdown with links */}
                            {!category.directLink && category.items && category.items.length > 0 && (
                                <div className={`category-dropdown ${activeDropdown === category.id ? 'active' : ''} ${category.id === 'clientlogin' ? 'login-dropdown' : ''}`}>
                                    {category.items.map((item, index) => (
                                        item.external ? (
                                            <a
                                                key={index}
                                                href={item.link}
                                                className="category-dropdown-item"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={handleLinkClick}
                                            >
                                                {item.icon && <i className={`las ${item.icon}`}></i>}
                                                {item.title}
                                            </a>
                                        ) : (
                                            <Link
                                                key={index}
                                                to={item.link}
                                                className="category-dropdown-item"
                                                onClick={handleLinkClick}
                                            >
                                                {item.icon && <i className={`las ${item.icon}`}></i>}
                                                {item.title}
                                            </Link>
                                        )
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </nav>
            </div>
        </div>
    );
};

export default TopCategoriesBar;
